import { Component } from "react";
import { compose } from "redux";

import _ from "underscore";

import TableNew from "../../../shared/Table";
import RefreshButton from "../../../shared/ui/Refresh.Button";

import FinancingDetails from "./FinancingDetails";

import { getFinancingColumns } from "./financingColumns";
import FinancingTableButtons from "./Table/FinancingTableButtons";

import { financingConnector } from "../../../services/financing/connector";
import { mplFinancingConnector } from "../../../services/financing/mpl.financing/MPL.Financing.connector";
import { userFinancingConnector } from "../../../services/financing/user.financing/connector";
import { usersConnector } from "../../../services/users/connectors/usersConnector";

class FinancingComponent extends Component {
  constructor(props) {
    super(props);

    let columns = getFinancingColumns(
      props.getFinancingPayoutInfo,
      props.registerPayout,
      props.closeFinancing,
      props.openFinancing,
      props.unPublishFinancing,
      props.publishFinancing,
      props.cancelFinancing,
      props.isMPL,
    );

    this.state = { columns };
  }

  UNSAFE_componentWillMount() {
    if (this.props.accountId) {
      this.props.getFinancingsPerAccount(this.props.accountId);
    } else if (
      this.props.financings.data &&
      !this.props.financings.data.length
    ) {
      this.getAllFinancings();
    }
  }

  getAllFinancings = () => {
    this.props.getFinancings();
  };

  render() {
    let refreshFunction = this.props.accountId
      ? this.props.getFinancingsPerAccount.bind(this, this.props.accountId)
      : this.getAllFinancings;

    let financingsProps = {
      closeFinancing: this.props.closeFinancing,
      openFinancing: this.props.openFinancing,
      unPublishFinancing: this.props.unPublishFinancing,
      publishFinancing: this.props.publishFinancing,
      realiseFinancing: this.props.realiseFinancing,
    };

    return (
      <div className="financing-layout body-height content-padding">
        <RefreshButton onRefreshClick={refreshFunction} />
        <h3>Savelend: Credits</h3>
        If stuff is missing here, check Loanstep views. Open/close is not
        implemented in Reloansys <br />
        Fully financed credits are eventually filtered out from this list.
        <br />
        {!this.props.financings.fetched ? (
          <div> Loading... </div>
        ) : (
          <div>
            <TableNew
              {...this.props}
              items={this.props.financings.data}
              columns={this.state.columns}
              tableKey={"open_financings"}
              actionColumnWidth={225}
              selectId={"Id"}
              detailsRenderer={(item, expanded) => {
                return (
                  <FinancingDetails
                    item={item}
                    investmentInfo={_.filter(
                      this.props.investmentInfo.data,
                      function (info) {
                        return info.CreditId === item.IntId;
                      },
                    )}
                    getInvestmentInfo={this.props.getInvestmentInfo}
                    fetched={this.props.investmentInfo.fetched}
                    expanded={expanded}
                  />
                );
              }}
              aboveContentRenderer={(getSelected, rows) => {
                return (
                  <div>
                    <FinancingTableButtons
                      getSelected={getSelected}
                      rows={rows}
                      {...financingsProps}
                    />
                  </div>
                );
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export const Financing = compose(financingConnector)(FinancingComponent);
export const MPLFinancing = compose(mplFinancingConnector)(FinancingComponent);
export const UserFinancing = compose(
  userFinancingConnector,
  usersConnector,
)(FinancingComponent);
